import React from "react";
import PropTypes from "prop-types";
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
	root: {
		width:'100%',
		height:'100%',
		textAlign: 'center',
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	text:{
		fontSize: '1.8em',
	},
	container:{
		marginTop: '-20px',
	},
	progress: {
		margin: theme.spacing(2),
	},
});

function LoadingScreen(props) {
	const { classes } = props;
	const text = props.text || 'Loading';
	return (
		<div className={classes.root}>
			<div className={classes.container}>
				<CircularProgress className={classes.progress} style={{ color: '#3182FB' }}  size={50} />
				<div className={classes.text}>{text}</div>
			</div>
		</div>
	)
}

LoadingScreen.propTypes = {
	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
		text: PropTypes.string.isRequired,
		container: PropTypes.string.isRequired,
		progress: PropTypes.string.isRequired,
	}).isRequired,

};

export default withStyles(styles)(LoadingScreen);